import api from './container';
import { confirm, handleMessages, load } from './util';
import { KEYCODES } from './util/keycodes';

$(document).on('submit', '[data-add-pendingcart-position]', function(event) {
  event.preventDefault();

  let qty = $(this).find('[data-add-pendingcart-position-quantity]').first();
  if (qty.length === 0) {
    qty = $(this).find('input[name="quantity"]').first();
  }

  const $form = qty.closest('form');
  const isConfiguration = $form.attr('data-item-configuration');
  if (isConfiguration) {
    const $itemId = $form.find('input[name="item_id"]');
    const $configurationForm = $itemId && $(`[data-item-configuration-form="${$itemId.val()}"]`);
    if ($configurationForm.length > 0) {
      const excludes = ['csrfmiddlewaretoken', 'quantity'];
      const data = $form.serializeArray();
      $configurationForm.serializeArray().filter(param => !excludes.includes(param.name))
        .forEach(param => data.push(param));

      const promise = $.ajax({
        url: isConfiguration,
        method: 'POST',
        data,
      }).then(handleMessages);

      load($form.closest('[data-reveal]'), promise, {
        errorClass: 'error',
      });
    }
  } else {
    api.updateQuantity(qty, 'pendingCart', true);
  }
});

$(document).on('submit', '[data-update-pendingcart-position]', event => event.preventDefault());

$(document).on('keydown', '[data-update-pendingcart-position-quantity]', function(event) {
  if (event.which === KEYCODES.ENTER) {
    api.updateQuantity($(this), 'pendingCart');
  }
});

$(document).on('keyup', '[data-update-pendingcart-position-quantity]', function() {
  $(this).closest('form')[this.value !== this.defaultValue ? 'addClass' : 'removeClass']('ready');
});

$(document).on('blur', '[data-update-pendingcart-position-quantity]', function() {
  api.updateQuantity($(this), 'pendingCart');
});

$(document).on('submit', '[data-update-pendingcart-position-text]', event => event.preventDefault());
$(document).on('change', '[data-update-pendingcart-position-text]', function(event) {
  event.preventDefault();
  api.setPositionText($(this), 'pendingCart');
});

$(document).on('submit', '[data-remove-pendingcart-position]', function(event) {
  event.preventDefault();
  api.removePosition($(this), 'pendingCart');
});

$(document).on('submit', '[data-pendingcart-update-form]', function(event) {
  event.preventDefault();
  api.updateContainer($(this).closest('form'), 'pendingCart');
});

$(document).on('submit', '[data-copy-pendingcart-positions]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');
  const $reveal = $form.closest('[data-reveal]');

  const promise = $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: $form.serializeArray(),
  }).then(handleMessages).then((data) => {
    setTimeout(() => $form.closest('[data-reveal]').foundation('close'), 1500);
    return data;
  });

  load($reveal, promise, {
    errorClass: 'error',
  });
});

$(document).on('submit', '[data-create-and-add-to-cart-form]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');
  const $reveal = $form.closest('[data-reveal]');
  const formData = $form.serializeArray();
  let action = $form.attr('action');

  const isConfiguration = $form.attr('data-item-configuration');
  if (isConfiguration) {
    action = isConfiguration;
    const $itemId = $form.find('input[name="item_id"]');
    const $configurationForm = $itemId && $(`[data-item-configuration-form="${$itemId.val()}"]`);
    if ($configurationForm.length > 0) {
      const excludes = ['csrfmiddlewaretoken', 'quantity'];
      $configurationForm.serializeArray().filter(param => !excludes.includes(param.name))
        .forEach(param => formData.push(param));
    }
  }

  if ($form.find('input[name="label"]').length === 0) {
    const label = $form.closest('[data-table-oninput]').find('[data-table-search-query]').text();
    formData.push({ name: 'label', value: label });
  }

  const promise = $.ajax({
    url: action,
    method: 'POST',
    data: formData,
  }).then(handleMessages).then((data) => {
    setTimeout(() => $form.closest('[data-reveal]').foundation('close'), 1500);
    return data;
  });

  load($reveal, promise, {
    errorClass: 'error',
  });
});

$(document).on('submit', '[data-pendingcart-import]', function(event) {
  event.preventDefault();
  api.importPositions($(this), 'pendingCart');
});

$(document).on('closeme.zf.reveal', '[data-pendingcart-import]', function() {
  this.reset();
  $(this).removeClass('error');
  $(this).find('[data-pendingcart-import-messages]').html('').hide()
    .removeClass('alert');
});

$(document).on('click', '[data-change-pendingcart-position-reel]', function(event) {
  event.preventDefault();
  api.changePositionReel($(this), 'pendingCart');
});

$(document).on('submit', '[data-update-pendingcart-position-reel]', function(event) {
  event.preventDefault();
  api.updatePositionReel($(this), 'pendingCart');
});

$(document).on('submit', '[data-add-pendingcart-position-diversitem]', function(event) {
  event.preventDefault();
  api.addPositionDiversItem($(this), 'pendingCart');
});

$(document).on('click', '[data-object-target="pendingCart"][data-object-set]', function (event) {
  event.preventDefault();
  api.setObject($(this), 'pendingCart');
});

$(document).on('click', '[data-object-target="pendingCart"][data-object-reset]', function (event) {
  event.preventDefault();
  api.resetObject($(this), 'pendingCart');
});

$(document).on('change', '[data-pendingcart-positions-ordering]', function(event) {
  event.preventDefault();
  $(this).submit();
});

$(document).on('click', '[data-pendingcart-group-update]', function(event) {
  event.preventDefault();
  api.showUpdateReveal($(this));
});

$(document).on('submit', '[data-pendingcart-group-update-form]', function(event) {
  event.preventDefault();
  api.updateGroup($(this), 'pendingCart');
});

$(document).on('submit', '[data-pendingcart-group-delete]', function(event) {
  event.preventDefault();
  const $form = $(this);
  $form.attr('data-confirm', $form.attr('data-pendingcart-group-delete'));

  confirm($form).then(({ confirmed, reveal }) => {
    $form.removeAttr('data-confirm');
    if (confirmed) {
      load(
        reveal,
        $.stores.pendingCart.post($form.attr('action'), $form.serializeArray()),
      ).then(() => {
        reveal.foundation('close');
      });
    }
  }).catch(() => {});
});
